import React from 'react';

// styles
const styles = require('./booking-items-flight.scss');

interface IProps {
  data: IFlightDetails;
  language: string;
  multiLang: any;
}

interface IState {
  flightDetails: IFlightDetails;
}

interface IFlightDetails {
  flightNumber: string;
  depatureAirportName: string;
  arrivalAirportName: string;
  marketingAirlineCode: string;
  operatingAirlineCode: string;
  flightStops: Array<any>;
}

class BookingItemsFlightComponent extends React.Component<IProps, IState> {

  constructor(props: any) {
    super(props);
    this.state = {
      flightDetails: props.data
    };
  }

  formatAirlineName(code) {
    const { language, multiLang } = this.props;

    switch (code) {
      case 'AA': {
        return multiLang[`AAFlight${language}`];
      }
      case 'BA': {
        return multiLang[`BAFlight${language}`];
      }
      case 'CX': {
        return multiLang[`CXFlight${language}`];
      }
      case 'EZY': {
        return multiLang[`EZYFlight${language}`];
      }
      case 'FY': {
        return multiLang[`FYFlight${language}`];
      }
      case 'QF': {
        return multiLang[`QFFlight${language}`];
      }
      case 'U2': {
        return multiLang[`U2Flight${language}`];
      }
      case 'EZY': {
        return multiLang[`U2Flight${language}`];
      }
      case 'VS': {
        return multiLang[`VSFlight${language}`];
      }
      case 'LX': {
        return multiLang[`LXFlight${language}`];
      }
      case 'SQ': {
        return multiLang[`SQFlight${language}`];
      }
      case 'EI': {
        return multiLang[`EIFlight${language}`];
      }
      case 'WK': {
        return multiLang[`EDWFlight${language}`];
      }
      case 'AF': {
        return multiLang[`AFFlight${language}`];
      }
      case 'KL': {
        return multiLang[`KLFlight${language}`];
      }
      case 'OS': {
        return multiLang[`OSFlight${language}`];
      }
      // new airlines
      case 'A3': {
        return multiLang[`A3Flight${language}`];
      }
      case 'AC': {
        return multiLang[`ACFlight${language}`];
      }
      case 'UX': {
        return multiLang[`UXFlight${language}`];
      }
      case 'DL': {
        return multiLang[`DLFlight${language}`];
      }
      case 'AZ': {
        return multiLang[`AZFlight${language}`];
      }
      case 'TP': {
        return multiLang[`TPFlight${language}`];
      }
      case 'TK': {
        return multiLang[`TKFlight${language}`];
      }
      case 'UA': {
        return multiLang[`UAFlight${language}`];
      }
      case 'TG': {
        return multiLang[`TGFlight${language}`];
      }
      case 'SN': {
        return multiLang[`SNFlight${language}`];
      }
      case 'LH': {
        return multiLang[`LHFlight${language}`];
      }
      case '4Y': {
        return multiLang[`4YFlight${language}`];
      }
      case 'DE': {
        return multiLang[`DEFlight${language}`];
      }
      default: {
        return multiLang[`flightText${language}`];
      }
    }
  };

  public render() {
    const { language, multiLang } = this.props;
    const listStops = this.state.flightDetails.flightStops.slice(1).map(function (item) {
      return (
        <div className={styles.stop} key={item.airportCode}></div>
      )
    });

    return (
      <div className={styles.card}>
        <div className={styles.cardHeader}>
          <h3>{multiLang[`flightDetailsText${language}`]}</h3>
        </div>
        <div className={styles.cardBody}>
          <div className={styles.flightVisual}>
            {this.state.flightDetails.depatureAirportName}
            <div className={styles.flightStops}>
              {listStops}
            </div>
            {this.state.flightDetails.arrivalAirportName}
          </div>
          {this.formatAirlineName(this.state.flightDetails.marketingAirlineCode.toLocaleUpperCase())}{this.state.flightDetails.marketingAirlineCode}{this.state.flightDetails.flightNumber}
        </div>
      </div>
    );
  }

}

export default BookingItemsFlightComponent;



// WEBPACK FOOTER //
// ./src/components/booking-items-flight/booking-items-flight.component.tsx